import {
  FETCH_DEVICES,
  FETCH_DEVICES_SUCCESS,
  FETCH_DEVICES_FAILURE,
  TOGGLE_DEVICE_STATUS,
  TOGGLE_DEVICE_STATUS_SUCCESS,
  TOGGLE_DEVICE_STATUS_FAILURE,
} from "./constants";

export const fetchDevices = (payload, onSuccess) => ({
  type: FETCH_DEVICES,
  payload,
  onSuccess,
});

export const fetchDevicesSuccess = (payload) => ({
  type: FETCH_DEVICES_SUCCESS,
  payload,
});

export const fetchDevicesFailure = () => ({
  type: FETCH_DEVICES_FAILURE,
});

export const toggleDeviceStatus = (payload, onSuccess) => ({
  type: TOGGLE_DEVICE_STATUS,
  payload,
  onSuccess,
});

export const toggleDeviceStatusSuccess = (payload) => ({
  type: TOGGLE_DEVICE_STATUS_SUCCESS,
  payload,
});

export const toggleDeviceStatusFailure = () => ({
  type: TOGGLE_DEVICE_STATUS_FAILURE,
});
